import { ResumeAnalysis } from "lib/resume-scoring/resume-analysis/resume-analyse-types";
import { EducationScoreAnalysis } from "lib/resume-scoring/types";
import { SectionCard } from "./SectionCard";
import { StatusItem } from "./StatusItem";

export const EducationCard = ({
  score,
  maxScore,
  analysis,
  className = "",
}: {
  score: EducationScoreAnalysis;
  maxScore: number;
  analysis: ResumeAnalysis["educations"];
  className?: string;
}) => {
  const criticalIssues = 0;
  const warningIssues = score.informationMistakeCount;
  const isEmptyState = analysis.individualEducationsAnalysis.length === 0;
  
  return (
    <SectionCard
      title="Education"
      icon="education"
      score={Math.floor(score.totalScore)}
      maxScore={maxScore}
      detailsLink="/score-check/education"
      emptyState={isEmptyState}
      className={className}
    >
      <ul className="mb-3 mt-3 gap-y-3 overflow-auto">
        {criticalIssues !== 0 ? (
          <StatusItem
            icon="issue"
            title="Major Issues"
            subtitle="Impacting score"
            status="count"
            count={criticalIssues}
          />
        ) : (
          <StatusItem
            icon="noIssue"
            title="No issue found"
            subtitle="Good impact in score"
            status="success"
          />
        )}

        {warningIssues !== 0 ? (
          <StatusItem
            icon="dateIssue"
            title="Missing Info"
            subtitle="Required information missing"
            status="count"
            count={warningIssues}
          />
        ) : (
          <StatusItem
            icon="dateIssue"
            title="Information obtained"
            subtitle="No info is missing"
            status="success"
          />
        )}
      </ul>
    </SectionCard>
  );
};
